<sb-icon.spinner icon="spinner" title="Please wait"/>
<style.scss>
  .spinner {
    --bg: #{$background-inverse-subtle};
    --fg: #{$background-strong};

    animation: rotate $motion-spinner infinite linear;
  }

  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }

    100% {
      transform: rotate(360deg);
    }
  }
</style>
